export function listener (selectInstance) {
  const selectElement = selectInstance.selectElement
  if (!selectElement) return

  selectElement.addEventListener('change', function (changeEvent) {
    // console.log('changeEvent', changeEvent, selectInstance)
    const selected = selectElement.value

    // Record the new selected value
    selectInstance.selectedValue = selected

    if (selectInstance.onChange) {
      selectInstance.onChange()
    }
  })

  selectElement.classList.add('listener-added')
}
